export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/lt.lyaml"));
at({ "lt": { "public": { "sampleString": "Eilut\u0117s pavyzdys" } } });
};